import { useEffect, useState } from 'react';

export function useDevice() {
  const [isLaptop, setIsLaptop] = useState(false);

  useEffect(() => {
    const checkDevice = () => {
      const hasFinePointer = window.matchMedia('(pointer: fine)').matches;
      const isLargeEnough = window.innerWidth >= 1024;

      setIsLaptop(isLargeEnough);
    };

    checkDevice();
    window.addEventListener('resize', checkDevice);
    return () => window.removeEventListener('resize', checkDevice);
  }, []);

  return { isLaptop };
}
